export const LEMONADE_AFFILIATE_URL =
  "https://lemonadeeurope.pxf.io/c/7679179/3976029/24305";

/**
 * Lemonade NL advertises contents insurance from €5 per month.
 * Verified 2026-09-14: https://www.lemonade.com/nl/inboedel/uitgelegd/inboedelverzekering-kosten/
 */
export const LEMONADE_STARTING_PRICE_EUR = 5;

export type LemonadeBannerVariant = "move" | "settle" | "compare";
export type LemonadeCardVariant = "keys" | "checklist" | "simple";
